import "./style.scss";
import ActivityPoints from "@components/ActivityPoints";
import playButton from "./img/play-btn.svg";
import NiceModal from "@ebay/nice-modal-react";

export default function VideoCard({
  title,
  points,
  image,
  time,
  videoTime,
  video,
  ident,
  ultraInsider,
  activationDescribe,
  fetchAllActivations,
}) {
  const showPoints = ultraInsider && activationDescribe?.completed === false;
  return (
    <div
      onClick={() =>
        NiceModal.show("video-modal", {
          videoTime: videoTime,
          video: video,
          image: image,
          ident: ident,
          ultraInsider: ultraInsider,
          fetchAllActivations: fetchAllActivations,
          completed: activationDescribe?.completed,
        })
      }
      className="video-card-component"
    >
      <div className="video-card">
        <div className="content">
          <div className="title">
            <h3>{title}</h3>
          </div>
          <div className="time">{time}</div>
          {showPoints && (
            <div className="points">
              <ActivityPoints customPointsCopy="punkte">
                5{points}
              </ActivityPoints>
            </div>
          )}
          <div className="play-button">
            <img src={playButton} alt="play" />
          </div>
        </div>
        <div className="image">
          <img src={image} alt="" />
        </div>
      </div>
    </div>
  );
}
